import { Box, Typography } from '@mui/material'
// import { useLocation } from 'react-router-dom'

export const Register = () => {
  // const location = useLocation()

  // const fromPage = (location.state as { from?: Location })?.from?.pathname || '/'

  return (
    <Box>
      <Typography variant="h2" align="center">
        Страница регистрации
        <p>Тут текст</p>
      </Typography>
    </Box>
  )
}
